<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hhBRWC/tc-custom/9781449479657.jpg?1737680567894" alt="This image is the cover for the book Salt & Silver"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Salt & Silver
      </h1>
      <p class="bookDescription body article font2">
        <b>Two surfers look for Latin America’s best waves—and best food: “Part travelogue, part cookbook, and all outstanding . . . an epic trip that’s well worth taking.” —<i>Publishers Weekly</i> (starred review)</b><br/><br/>This book traces the journey of surfers Johannes Riffelmacher and Thomas Kosikowski as they make their way through Central and South America—reporting on the best surfing locations, chronicling the stories of local surfers and restaurant owners, and compiling recipes representative of each area. <br/><br/>The narrative begins in Cuba with beautiful images of the city and the beaches, as well as stories related to the Cuban surfing community and a discussion of popular Cuban dishes. Next is a tour of Mexico—first with street tacos, a trip through Mexican markets, and a day spent in the urban graffiti scene of Guadalajara; then with Tostadas de Pulpo (Octopus Crackers), Shrimp and Portobello Burgers, and a glimpse into life in the remote surfing town of San Pancho. The Mexican leg of the journey draws to a conclusion with seven-meter-waves, BBQ, and Tajine in Rio Nexpa, as well as “a perfect righthander barreling of a point” in scenic La Ticla. Then the two men make their way through Nicaragua, Costa Rica, Panama, Ecuador, Peru, and finally Chile, exploring the beaches as well as the kitchens of each location.<br/><br/> <br/><br/>Interspersed throughout are more than ninety regional recipes, over 250 stunning photographs, and a wide array of tips and stories ranging from social commentary to pointers on how to rent a “Hamaquera” in La Ticla for three dollars a night.<br/><br/>“The recipes . . . are real-deal, the photography is breathtaking, and the tales of full immersion are inspiring.” —Nick McGregor, <i>Eastern Surf Magazine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Johannes Riffelmacher
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6db406e9